t = require('views/internal/teacup-with-helpers')('kiln_changeset_preview')

module.exports = ->
  reviews = t.mustacheVar('reviews') ? []

  t.div '.attachment-extra-info-header', ->
    key = if reviews.length == 0
      'changeset-no-reviews'
    else
      'changeset'

    t.format key,
      url: t.mustacheVar('url')
      shortHash: t.mustacheVar('shortHash')
      author: t.mustacheVar('author')

    t.mustacheBlock 'reviews', ->
      t.span '.quiet', ->
        t.a { href: t.mustacheVar('url'), target: '_blank' }, ->
          t.text t.mustacheVar('status')

  t.div '.attachment-extra-info-details.markeddown', ->
    t.raw t.mustacheVar('commitMessageHtml')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/kiln_changeset_preview.coffee